require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-grafenschachen.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-grafenschachen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-grafenschachen!./.cache/json/betreuungseinrichtungen-oberwart-grafenschachen.json
// module id = 1004
// module chunks = 231608221292675